import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { normalize } from '../utils';
import { union, merge } from 'lodash';

const resource = (state, { type, payload }) => {
  switch (type) {
    case 'WORKROOM_RESOURCE_REQUEST':
      return {
        ...state,
        ...payload,
        loading: true,
      };
    case 'WORKROOM_RESOURCE_SUCCESS':
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'WORKROOM_RESOURCE_REQUEST':
    case 'WORKROOM_RESOURCE_SUCCESS':
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS': {
      const id = payload.id !== null && payload.id !== undefined ?
                 payload.id : payload.result;
      // If payload has an id, it's a REQUEST action otherwise
      // the id is in the result field from normalizr
      const resourcePayload = payload.entities && payload.entities.workrooms
                           && payload.entities.workrooms[id];
      return {
        ...state,
        [id]: resource(state[id], { type, payload: resourcePayload }),
      };
    }
    case 'WORKROOM_LIST_SUCCESS':
      return Object.assign({}, state, normalize(payload.workrooms));
    case 'ESTIMATOR_LIST_SUCCESS':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'INSTALLER_RESOURCE_SUCCESS': {
      const wr = payload.entities && payload.entities.workrooms;
      return merge({}, state, wr);
    }
    default:
      return state;
  }
};

const defaultFilters = {
  data: {
    is_active: true,
    query: null,
  },
  idsByFilter: [],
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'WORKROOM_LIST_SUCCESS':
      return {
        ...state,
        idsByFilter: union(state.idsByFilter || [], payload.workrooms.map(item => item.id)),
      };
    case 'WORKROOM_SET_FILTER':
      return {
        ...state,
        idsByFilter: [],
        data: Object.assign({}, payload),
      };
    case 'WORKROOM_RESET_FILTERS':
      return defaultFilters;
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        idsByFilter: [],
      };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  page: 1,
  hasNextPage: true,
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'WORKROOM_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'WORKROOM_RESET_PAGINATION':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
      };
    case 'WORKROOM_RESOURCE_CREATE_SUCCESS':
    case 'WORKROOM_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        errors: {},
        page: 1,
        hasNextPage: true,
      };
    case 'WORKROOM_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        page: state.page + 1,
        hasNextPage: payload.has_next_page,
      };
    case 'WORKROOM_LIST_FAILURE':
    case 'WORKROOM_RESOURCE_CREATE_FAILURE':
    case 'WORKROOM_RESOURCE_UPDATE_FAILURE':
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: payload.errors,
      };
    case 'WORKROOM_RESOURCE_REQUEST':
    case 'WORKROOM_RESOURCE_SUCCESS':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
  filters,
});

const getById = state => id => state.byId[id];
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getLoaded = state => state.common.loaded;
const getFiltersData = state => state.filters.data;
const idsByFilter = state => state.filters.idsByFilter;
const getErrors = state => state.common.errors;
const getFilteredByIds = state => ids => ids.map(id => getById(state)(id));

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup(id)),
);

export {
  getList,
  getHasNextPage,
  getPage,
  getLoading,
  getLoaded,
  getErrors,
  getById,
  getFiltersData,
  getFilteredByIds,
};



// WEBPACK FOOTER //
// ./client/app/reducers/workrooms.js